"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAnalyticsInfo = getAnalyticsInfo;
exports.getSearchQueryAnalytics = getSearchQueryAnalytics;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _exchangeSearchCommon = require("@mulesoft/exchange-search-common");
const _excluded = ["category", "field"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function getAnalyticsInfo(assets) {
  if (assets.length === 0) {
    return null;
  }
  const totalMinorCount = assets.reduce((accum, asset) => accum + asset.highlight.scores.count, 0);
  const matchedMinorCountAverage = totalMinorCount / assets.length;
  const updatedOutsideBatchCount = assets.reduce((accum, asset) => asset.replacedOutsideBatch ? accum + 1 : accum, 0);
  const updatedOutsideBatchRatio = updatedOutsideBatchCount / assets.length;
  const latestMatchedMinorHighestScoreCount = assets.reduce((accum, asset) => {
    const {
      highlight,
      score
    } = asset;
    const {
      scores
    } = highlight;
    return score === scores.latestVersionScore ? accum + 1 : accum;
  }, 0);
  const latestMatchedMinorHighestScorePercentage = latestMatchedMinorHighestScoreCount / assets.length * 100;
  return {
    updatedOutsideBatchCount,
    updatedOutsideBatchRatio,
    matchedMinorCountAverage,
    latestMatchedMinorHighestScoreCount,
    latestMatchedMinorHighestScorePercentage
  };
}
function getFieldFilterAnalytics(fieldFilters, facets) {
  const {
    conditions,
    operators,
    dataTypes
  } = fieldFilters.map(_exchangeSearchCommon.parseCustomFieldFilter).reduce((accum, {
    key,
    operator,
    identifier
  }) => {
    const filterKey = [key, operator, identifier].join(':');
    if (!accum.conditions.includes(filterKey)) {
      accum.conditions.push(filterKey);
      if (!accum.operators.includes(operator)) {
        accum.operators.push(operator);
      }
      const field = facets.fields.find(({
        tagKey
      }) => tagKey === key);
      if (field !== null && field !== void 0 && field.dataType && !accum.dataTypes.includes(field.dataType)) {
        accum.dataTypes.push(field.dataType);
      }
    }
    return accum;
  }, {
    conditions: [],
    operators: [],
    dataTypes: []
  });
  return {
    conditionsCount: conditions.length,
    dataTypes,
    operators,
    selectedValues: fieldFilters,
    selectedValuesCount: fieldFilters.length
  };
}
function getCategoryFilterAnalytics(categoryFilters) {
  const {
    categories
  } = categoryFilters.map(categoryFilter => categoryFilter.split(':')).reduce((accum, [category]) => {
    if (!accum.categories.includes(category)) {
      accum.categories.push(category);
    }
    return accum;
  }, {
    categories: []
  });
  return {
    categoriesCount: categories.length,
    selectedValues: categoryFilters,
    selectedValuesCount: categoryFilters.length
  };
}
function getSearchQueryAnalytics(appliedFilters, facets) {
  const _appliedFilters$getAs = appliedFilters.getAsANGQuery(),
    {
      category,
      field
    } = _appliedFilters$getAs,
    rest = (0, _objectWithoutProperties2.default)(_appliedFilters$getAs, _excluded);
  return _objectSpread(_objectSpread({}, rest), {}, {
    category: getCategoryFilterAnalytics(category),
    field: getFieldFilterAnalytics(field, facets)
  });
}
//# sourceMappingURL=analytics.js.map